import React, { useState, useMemo, useContext } from "react";
import {Workbook} from "exceljs";
import { CommandBar, FontIcon, ICommandBarItemProps } from "@fluentui/react";
import { gql, useMutation, useQuery } from "@apollo/client";
import { useBoolean } from "@fluentui/react-hooks";
import Notification, { INotification } from "../InlineNotification";
import { useDropzone } from "react-dropzone";
import AppContext from "../../AppContext";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { i18n } from "i18next";

const TEMPLATE_FILES: Record<string, string> = {
  ES: "Monitor de Ventas - Datos de ventas.xlsx",
  PT: "Monitor de Ventas - Datos de ventasPT-ES.xlsx",
  PT_EN: "Monitor de Ventas - Datos de ventasPT-EN.xlsx",
};

function resolveCountry(hostname: string, language: string): keyof typeof TEMPLATE_FILES {
  const host = hostname.toLowerCase();
  const isPT =
    host.includes("pt-qa") ||
    host.includes("pt") ||
    host.includes("localhost");

  if (isPT && language === "en") return "PT_EN";
  if (isPT) return "PT";
  return "ES";
}
const sheetToJson = (worksheet: any) => {
  const rows: any[] = [];
  worksheet.eachRow({ includeEmpty: false }, function (row: any) {
    // Fórmulas en Excel
    const rowValues = row.values.slice(1).map((cell: any) => {
      if (cell && typeof cell === 'object' && 'result' in cell) {
        return cell.result;
      }
      if (cell && typeof cell === 'object' && 'formula' in cell) {
        return cell.result !== undefined ? cell.result : null;
      }
      return cell;
    });
    rows.push(rowValues);
  });
  if (rows.length === 0) return [];
  const headers = rows[0];
  return rows.slice(1).map(rowArr => {
    const obj: any = {};
    headers.forEach((header: string, idx: number) => {
      obj[header] = rowArr[idx];
    });
    return obj;
  });
};
//const numberOfValues = 95
const numberOfValues = 173;
const errorPlantillaEn= "The template format is not correct, please try downloading it again.";
const errorPlantilla =
  "El formato de la plantilla es incorrecto. Por favor, vuelva a descargarla.";
const defaultKeys = [
  "Código de cadena",
  "Semana",
  "Año",
  "Nº Locales comparables",
  "Nº Locales comparables que reportan",
  "Ventas comparables",
  "Ventas comparables (ap)",
  "Tickets comparables",
  "Tickets comparables (ap)",
  "Aperturas",
  "Cierres",
  "Nº Locales",
  "Nº Locales que reportan",
  "Ventas totales",
  "Ventas totales (año pasado)",
  "Tickets totales",
  "Tickets totales (año pasado)",
  "Ventas delivery",
  "Ventas delivery (ap)",
  "Tickets delivery",
  "Tickets delivery (ap)",
  "Locales con delivery",
  "Locales con delivery (ap)",
  "Ventas take away",
  "Ventas take away (ap)",
  "Tickets take away",
  "Tickets take away (ap)",
  "Ventas local",
  "Ventas local (ap)",
  "Tickets local",
  "Tickets local (ap)",
  "Ventas calle",
  "Ventas calle (ap)",
  "Tickets calle",
  "Tickets calle (ap)",
  "Ventas c.comercial",
  "Ventas c.comercial (ap)",
  "Tickets c.comercial",
  "Tickets c.comercial (ap)",
  "Ventas concesiones",
  "Ventas concesiones (ap)",
  "Tickets concesiones",
  "Tickets concesiones (ap)",
  "Ventas resto ubicaciones",
  "Ventas resto ubicaciones (ap)",
  "Tickets resto ubicaciones",
  "Tickets resto ubicaciones (ap)",
  "Ventas Madrid",
  "Ventas Madrid (ap)",
  "Tickets Madrid",
  "Tickets Madrid (ap)",
  "Ventas Barcelona",
  "Ventas Barcelona (ap)",
  "Tickets Barcelona",
  "Tickets Barcelona (ap)",
  "Ventas Zona 3",
  "Ventas Zona 3 (ap)",
  "Tickets Zona 3",
  "Tickets Zona 3 (ap)",
  "Ventas Zona 4",
  "Ventas Zona 4 (ap)",
  "Tickets Zona 4",
  "Tickets Zona 4 (ap)",
  "Ventas Zona 5",
  "Ventas Zona 5 (ap)",
  "Tickets Zona 5",
  "Tickets Zona 5 (ap)",
  "Ventas Zona 6",
  "Ventas Zona 6 (ap)",
  "Tickets Zona 6",
  "Tickets Zona 6 (ap)",
  "Ventas realizadas en la mañana",
  "Ventas realizadas en la mañana (ap)",
  "Tickets realizadas en la mañana",
  "Tickets realizadas en la mañana (ap)",
  "Ventas realizadas en la tarde",
  "Ventas realizadas en la tarde (ap)",
  "Tickets realizadas en la tarde",
  "Tickets realizadas en la tarde (ap)",
  "Ventas realizadas en comidas de diario",
  "Ventas realizadas en comidas de diario (ap)",
  "Tickets realizadas en comidas de diario",
  "Tickets realizadas en comidas de diario (ap)",
  "Ventas realizadas en cenas de diario",
  "Ventas realizadas en cenas de diario (ap)",
  "Tickets realizadas en cenas de diario",
  "Tickets realizadas en cenas de diario (ap)",
  "Ventas realizadas en comidas de fin de semana",
  "Ventas realizadas en comidas de fin de semana (ap)",
  "Tickets realizadas en comidas de fin de semana",
  "Tickets realizadas en comidas de fin de semana (ap)",
  "Ventas realizadas en cenas de fin de semana",
  "Ventas realizadas en cenas de fin de semana (ap)",
  "Tickets realizadas en cenas de fin de semana",
  "Tickets realizadas en cenas de fin de semana (ap)",
  "Locales self standing durante la semana",
  "Locales self standing durante la semana (ap)",
  "Ventas comparables delivery",
  "Ventas comparables delivery (ap)",
  "Tickets comparables delivery",
  "Tickets comparables delivery (ap)",
  "Ventas comparables take away",
  "Ventas comparables take away (ap)",
  "Tickets comparables take away",
  "Tickets comparables take away (ap)",
  "Ventas comparables local",
  "Ventas comparables local (ap)",
  "Tickets comparables local",
  "Tickets comparables local (ap)",
  "Ventas comparables calle",
  "Ventas comparables calle (ap)",
  "Tickets comparables calle",
  "Tickets comparables calle (ap)",
  "Ventas comparables c.comercial",
  "Ventas comparables c.comercial (ap)",
  "Tickets comparables c.comercial",
  "Tickets comparables c.comercial (ap)",
  "Ventas comparables concesiones",
  "Ventas comparables concesiones (ap)",
  "Tickets comparables concesiones",
  "Tickets comparables concesiones (ap)",
  "Ventas comparables resto ubicaciones",
  "Ventas comparables resto ubicaciones (ap)",
  "Tickets comparables resto ubicaciones",
  "Tickets comparables resto ubicaciones (ap)",
  "Ventas comparables Madrid",
  "Ventas comparables Madrid (ap)",
  "Tickets comparables Madrid",
  "Tickets comparables Madrid (ap)",
  "Ventas comparables Barcelona",
  "Ventas comparables Barcelona (ap)",
  "Tickets comparables Barcelona",
  "Tickets comparables Barcelona (ap)",
  "Ventas comparables zona 3",
  "Ventas comparables zona 3 (ap)",
  "Tickets comparables zona 3",
  "Tickets comparables zona 3 (ap)",
  "Ventas comparables zona 4",
  "Ventas comparables zona 4 (ap)",
  "Tickets comparables zona 4",
  "Tickets comparables zona 4 (ap)",
  "Ventas comparables zona 5",
  "Ventas comparables zona 5 (ap)",
  "Tickets comparables zona 5",
  "Tickets comparables zona 5 (ap)",
  "Ventas comparables zona 6",
  "Ventas comparables zona 6 (ap)",
  "Tickets comparables zona 6",
  "Tickets comparables zona 6 (ap)",
  "Ventas comparables en la mañana",
  "Ventas comparables en la mañana (ap)",
  "Tickets comparables en la mañana",
  "Tickets comparables en la mañana (ap)",
  "Ventas comparables en la tarde",
  "Ventas comparables en la tarde (ap)",
  "Tickets comparables en la tarde",
  "Tickets comparables en la tarde (ap)",
  "Ventas comparables comidas de diario",
  "Ventas comparables comidas de diario (ap)",
  "Tickets comparables comidas de diario",
  "Tickets comparables comidas de diario (ap)",
  "Ventas comparables cenas de diario",
  "Ventas comparables cenas de diario (ap)",
  "Tickets comparables cenas de diario",
  "Tickets comparables cenas de diario (ap)",
  "Ventas comparables comidas fin de semana",
  "Ventas comparables comidas fin de semana (ap)",
  "Tickets comparables comidas fin de semana",
  "Tickets comparables comidas fin de semana (ap)",
  "Ventas comparables cenas fin de semana",
  "Ventas comparables cenas fin de semana (ap)",
  "Tickets comparables cenas fin de semana",
  "Tickets comparables cenas fin de semana (ap)",
  // NUEVAS COLUMNAS - Locales por región
  // "Locales Madrid",
  // "Locales Barcelona",
  // "Locales Zona 3",
  // "Locales Zona 4",
  // "Locales Zona 5",
  // "Locales Zona 6",
  // NUEVAS COLUMNAS - Agregadores
  // "Ventas agregadores",
  // "Ventas agregadores (ap)",
  // "Tickets agregadores",
  // "Tickets agregadores (ap)",
  // NUEVAS COLUMNAS - Propios
  // "Ventas propios",
  // "Ventas propios (ap)",
  // "Tickets propios",
  // "Tickets propios (ap)",
  // NUEVAS COLUMNAS - Turismo
  // "Ventas turismo",
  // "Ventas turismo (ap)",
  // "Tickets turismo",
  // "Tickets turismo (ap)"
];
//const defaultDBKeys = ["cadena", "semana", "anyo", "locales_comp", "localesrep_comp", "ventas_comp", "ventas_comp_ap", "tickets_comp", "tickets_comp_ap", "locales_aperturas", "locales_cierres", "locales", "localesrep", "ventas", "ventas_ap", "tickets", "tickets_ap", "del_ventas", "del_ventas_ap", "del_tickets", "del_tickets_ap", "del_locales", "del_localesrep", "taw_ventas", "taw_ventas_ap", "taw_tickets", "taw_tickets_ap", "local_ventas", "local_ventas_ap", "local_tickets", "local_tickets_ap", "calle_ventas", "calle_ventas_ap", "calle_tickets", "calle_tickets_ap", "cc_ventas", "cc_ventas_ap", "cc_tickets", "cc_tickets_ap", "conces_ventas", "conces_ventas_ap", "conces_tickets", "conces_tickets_ap", "otros_ventas", "otros_ventas_ap", "otros_tickets", "otros_tickets_ap", "z1_ventas", "z1_ventas_ap", "z1_tickets", "z1_tickets_ap", "z2_ventas", "z2_ventas_ap", "z2_tickets", "z2_tickets_ap", "z3_ventas", "z3_ventas_ap", "z3_tickets", "z3_tickets_ap", "z4_ventas", "z4_ventas_ap", "z4_tickets", "z4_tickets_ap", "z5_ventas", "z5_ventas_ap", "z5_tickets", "z5_tickets_ap", "z6_ventas", "z6_ventas_ap", "z6_tickets", "z6_tickets_ap", "t1_ventas", "t1_ventas_ap", "t1_tickets", "t1_tickets_ap", "t2_ventas", "t2_ventas_ap", "t2_tickets", "t2_tickets_ap", "t3_ventas", "t3_ventas_ap", "t3_tickets", "t3_tickets_ap", "t4_ventas", "t4_ventas_ap", "t4_tickets", "t4_tickets_ap", "t5_ventas", "t5_ventas_ap", "t5_tickets", "t5_tickets_ap", "t6_ventas", "t6_ventas_ap", "t6_tickets", "t6_tickets_ap", "ss_locales", "ss_locales_comp"]
//const defaultDBKeys1 = ["cadena", "semana", "anyo", "locales_comp", "localesrep_comp", "ventas_comp", "ventas_comp_ap", "tickets_comp", "tickets_comp_ap", "locales_aperturas", "locales_cierres", "locales", "localesrep", "ventas", "ventas_ap", "tickets", "tickets_ap", "del_ventas", "del_ventas_ap", "del_tickets", "del_tickets_ap", "del_locales", "del_localesrep", "taw_ventas", "taw_ventas_ap", "taw_tickets", "taw_tickets_ap", "local_ventas", "local_ventas_ap", "local_tickets", "local_tickets_ap", "calle_ventas", "calle_ventas_ap", "calle_tickets", "calle_tickets_ap", "cc_ventas", "cc_ventas_ap", "cc_tickets", "cc_tickets_ap", "conces_ventas", "conces_ventas_ap", "conces_tickets", "conces_tickets_ap", "otros_ventas", "otros_ventas_ap", "otros_tickets", "otros_tickets_ap", "z1_ventas", "z1_ventas_ap", "z1_tickets", "z1_tickets_ap", "z2_ventas", "z2_ventas_ap", "z2_tickets", "z2_tickets_ap", "z3_ventas", "z3_ventas_ap", "z3_tickets", "z3_tickets_ap", "z4_ventas", "z4_ventas_ap", "z4_tickets", "z4_tickets_ap", "z5_ventas", "z5_ventas_ap", "z5_tickets", "z5_tickets_ap", "z6_ventas", "z6_ventas_ap", "z6_tickets", "z6_tickets_ap", "t1_ventas", "t1_ventas_ap", "t1_tickets", "t1_tickets_ap", "t2_ventas", "t2_ventas_ap", "t2_tickets", "t2_tickets_ap", "t3_ventas", "t3_ventas_ap", "t3_tickets", "t3_tickets_ap", "t4_ventas", "t4_ventas_ap", "t4_tickets", "t4_tickets_ap", "t5_ventas", "t5_ventas_ap", "t5_tickets", "t5_tickets_ap", "t6_ventas", "t6_ventas_ap", "t6_tickets", "t6_tickets_ap"]

const defaultDBKeys = [
  "cadena",
  "semana",
  "anyo",
  "locales_comp",
  "localesrep_comp",
  "ventas_comp",
  "ventas_comp_ap",
  "tickets_comp",
  "tickets_comp_ap",
  "locales_aperturas",
  "locales_cierres",
  "locales",
  "localesrep",
  "ventas",
  "ventas_ap",
  "tickets",
  "tickets_ap",
  "del_ventas",
  "del_ventas_ap",
  "del_tickets",
  "del_tickets_ap",
  "del_locales",
  "del_locales_ap",
  "taw_ventas",
  "taw_ventas_ap",
  "taw_tickets",
  "taw_tickets_ap",
  "local_ventas",
  "local_ventas_ap",
  "local_tickets",
  "local_tickets_ap",
  "calle_ventas",
  "calle_ventas_ap",
  "calle_tickets",
  "calle_tickets_ap",
  "cc_ventas",
  "cc_ventas_ap",
  "cc_tickets",
  "cc_tickets_ap",
  "conces_ventas",
  "conces_ventas_ap",
  "conces_tickets",
  "conces_tickets_ap",
  "otros_ventas",
  "otros_ventas_ap",
  "otros_tickets",
  "otros_tickets_ap",
  "z1_ventas",
  "z1_ventas_ap",
  "z1_tickets",
  "z1_tickets_ap",
  "z2_ventas",
  "z2_ventas_ap",
  "z2_tickets",
  "z2_tickets_ap",
  "z3_ventas",
  "z3_ventas_ap",
  "z3_tickets",
  "z3_tickets_ap",
  "z4_ventas",
  "z4_ventas_ap",
  "z4_tickets",
  "z4_tickets_ap",
  "z5_ventas",
  "z5_ventas_ap",
  "z5_tickets",
  "z5_tickets_ap",
  "z6_ventas",
  "z6_ventas_ap",
  "z6_tickets",
  "z6_tickets_ap",
  "t1_ventas",
  "t1_ventas_ap",
  "t1_tickets",
  "t1_tickets_ap",
  "t2_ventas",
  "t2_ventas_ap",
  "t2_tickets",
  "t2_tickets_ap",
  "t3_ventas",
  "t3_ventas_ap",
  "t3_tickets",
  "t3_tickets_ap",
  "t4_ventas",
  "t4_ventas_ap",
  "t4_tickets",
  "t4_tickets_ap",
  "t5_ventas",
  "t5_ventas_ap",
  "t5_tickets",
  "t5_tickets_ap",
  "t6_ventas",
  "t6_ventas_ap",
  "t6_tickets",
  "t6_tickets_ap",
  "del_ventas_comp",
  "del_tickets_comp",
  "taw_ventas_comp",
  "taw_tickets_comp",
  "local_ventas_comp",
  "local_tickets_comp",
  "calle_ventas_comp",
  "calle_tickets_comp",
  "cc_ventas_comp",
  "cc_tickets_comp",
  "conces_ventas_comp",
  "conces_tickets_comp",
  "otros_ventas_comp",
  "otros_tickets_comp",
  "z1_ventas_comp",
  "z1_tickets_comp",
  "z2_ventas_comp",
  "z2_tickets_comp",
  "z3_ventas_comp",
  "z3_tickets_comp",
  "z4_ventas_comp",
  "z4_tickets_comp",
  "z5_ventas_comp",
  "z5_tickets_comp",
  "z6_ventas_comp",
  "z6_tickets_comp",
  "t1_ventas_comp",
  "t1_tickets_comp",
  "t2_ventas_comp",
  "t2_tickets_comp",
  "t3_ventas_comp",
  "t3_tickets_comp",
  "t4_ventas_comp",
  "t4_tickets_comp",
  "t5_ventas_comp",
  "t5_tickets_comp",
  "t6_ventas_comp",
  "t6_tickets_comp",
//   "localesmadrid",
// "localesbarcelona",
// "localeszona3",
// "localeszona4",
// "localeszona5",
// "localeszona6",
// "ventasagregadores",
// "ventasagregadoresap",
// "ticketsagregadores",
// "ticketsagregadoresap",
// "ventaspropios",
// "ventaspropiosap",
// "ticketspropios",
// "ticketspropiosap",
// "ventasturismo",
// "ventasturismoap",
// "ticketsturismo",
// "ticketsturismoap"
];
const defaultDBKeys1 = [
  "cadena",
  "semana",
  "anyo",
  "locales_comp",
  "localesrep_comp",
  "ventas_comp",
  "ventas_comp_ap",
  "tickets_comp",
  "tickets_comp_ap",
  "locales_aperturas",
  "locales_cierres",
  "locales",
  "localesrep",
  "ventas",
  "ventas_ap",
  "tickets",
  "tickets_ap",
  "del_ventas",
  "del_ventas_ap",
  "del_tickets",
  "del_tickets_ap",
  "del_locales",
  "del_localesrep",
  "taw_ventas",
  "taw_ventas_ap",
  "taw_tickets",
  "taw_tickets_ap",
  "local_ventas",
  "local_ventas_ap",
  "local_tickets",
  "local_tickets_ap",
  "calle_ventas",
  "calle_ventas_ap",
  "calle_tickets",
  "calle_tickets_ap",
  "cc_ventas",
  "cc_ventas_ap",
  "cc_tickets",
  "cc_tickets_ap",
  "conces_ventas",
  "conces_ventas_ap",
  "conces_tickets",
  "conces_tickets_ap",
  "otros_ventas",
  "otros_ventas_ap",
  "otros_tickets",
  "otros_tickets_ap",
  "z1_ventas",
  "z1_ventas_ap",
  "z1_tickets",
  "z1_tickets_ap",
  "z2_ventas",
  "z2_ventas_ap",
  "z2_tickets",
  "z2_tickets_ap",
  "z3_ventas",
  "z3_ventas_ap",
  "z3_tickets",
  "z3_tickets_ap",
  "z4_ventas",
  "z4_ventas_ap",
  "z4_tickets",
  "z4_tickets_ap",
  "z5_ventas",
  "z5_ventas_ap",
  "z5_tickets",
  "z5_tickets_ap",
  "z6_ventas",
  "z6_ventas_ap",
  "z6_tickets",
  "z6_tickets_ap",
  "t1_ventas",
  "t1_ventas_ap",
  "t1_tickets",
  "t1_tickets_ap",
  "t2_ventas",
  "t2_ventas_ap",
  "t2_tickets",
  "t2_tickets_ap",
  "t3_ventas",
  "t3_ventas_ap",
  "t3_tickets",
  "t3_tickets_ap",
  "t4_ventas",
  "t4_ventas_ap",
  "t4_tickets",
  "t4_tickets_ap",
  "t5_ventas",
  "t5_ventas_ap",
  "t5_tickets",
  "t5_tickets_ap",
  "t6_ventas",
  "t6_ventas_ap",
  "t6_tickets",
  "t6_tickets_ap",
];

function cleanVarName(name: string) {
  if (!name || typeof name !== "string") return "";
  name = name.replaceAll("ñ", "n");
  return name
    .replace(/( |:|º|\.|\(|\))/g, "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase(); // nosonar
}

const ExcelLoader = ({ darkMode }: { darkMode?: boolean }) => {
  const{t,i18n}=useTranslation();
  const { user } = useContext(AppContext);

  const [table, setTable] = useState<any>();
  const [allItems, setAllItems] = useState<any>([]);
  const [index, setIndex] = useState(0);
  const [
    showNotification,
    { toggle: toggleNotification, setFalse: closeNotification },
  ] = useBoolean(false);
  const [notification, setNotification] = useState<{
    text: string;
    type: INotification;
  }>({ text: "", type: "default" });

  const getError = (data: any) => {
    let error = "";
    if (
      !(
        Object.entries(data).length === numberOfValues ||
        Object.entries(data).length === numberOfValues + 2
      )
    )
      error =
        t('Number-fields-not-match');
    if (data["semana"] === undefined)
      error = t('Fulfill-all-cells');
    return error;
  };

  const handleDropFile = async (file: File[]) => {
    let formData = new FormData();
    formData.append("file", file[0]);
    formData.append("user", user);
    await fetch("./uploads/upload.php", {
      method: "POST",
      body: formData,
    });

    closeNotification();

    const isCSV = file[0]?.name.slice(-4) === ".csv";
    const isXLS = file[0]?.name.slice(-4) === ".xls";

    let reader = new FileReader();
    
    // Leer todos los archivos como ArrayBuffer
    reader.readAsArrayBuffer(file[0]);

    reader.onloadend = async (e) => {
      try {
        if (e.target === null || e.target.result === null)
          throw new Error(t('Error-loading-template'));

        let relevantdata: any[];

        if (!isCSV) {
          // Para archivos Excel (.xls y .xlsx) usar ExcelJS
          let data: any = undefined;
          if (typeof e?.target?.result === "object")
            data = new Uint8Array(e.target.result);

          const workbook = new Workbook();
          await workbook.xlsx.load(data);
          const worksheet = workbook.worksheets[0];
          relevantdata = sheetToJson(worksheet);
        } else {
          // CSV
          let text = "";
          if (typeof e?.target?.result === "string") {
            text = e.target.result;
          } else {
            const decoder = new TextDecoder("utf-8");
            text = decoder.decode(new Uint8Array(e.target.result as ArrayBuffer));
          }
          const workbook = new Workbook();
          // @ts-ignore
          await workbook.csv.read(text);
          const worksheet = workbook.worksheets[0];
          relevantdata = sheetToJson(worksheet);
        }


        let error = "";
        let cTable = [];

        if (
          isCSV &&
          !(
            JSON.stringify(Object.values(relevantdata[3])) ===
              JSON.stringify(defaultDBKeys) ||
            JSON.stringify(Object.values(relevantdata[3])) ===
              JSON.stringify(defaultDBKeys1)
          )
        )
          throw new Error(i18n.language === "en" ? errorPlantillaEn : errorPlantilla);

        if (!isCSV && relevantdata.length < 5) {
          error = i18n.language === "en" ? errorPlantillaEn : errorPlantilla;
        } else {
          if (isCSV && Object.values(relevantdata[3]).length < numberOfValues)
            error = i18n.language === "en" ? errorPlantillaEn : errorPlantilla;
          //const plantillas = ["Código de 5 digitos insertado por Ameba ", "Código de 6 dígitos facilitado por Ameba", "Código de 6 digitos ifacilitado por Ameba ", "Código de cadena de 6 dígitos facilitado por Ameba"]

          let keys: string[];
          let plantilla = 0;
          if (isCSV) {
            plantilla = 4;
            //}else{
            //	keys = Object.values(relevantdata[3])
            //	if(typeof keys[2] === "number" && plantillas.includes(`${Object.values(relevantdata[2])[0]}`)) {
            //		plantilla = 1
            //	}
          }
          keys = defaultKeys; // Para admitir varios tipos de plantilla, forzamos siempre las claves por defecto

          //if (plantilla===0 && JSON.stringify(keys) !== JSON.stringify(defaultKeys)) throw new Error(errorPlantilla)

          let cAllItems: any = [];
          //if(relevantdata.length>4) throw new Error("Sólo puede cargar datos para la semana en curso. Para cargar datos históricos, póngase en contacto con Ameba Research.")

          for (let row = 4 - plantilla; row < relevantdata.length; row++) {
            let obj: any = {};
            let values: any[] = Object.values(relevantdata[row]);
            let cAllItem: any = [];

            if (keys.length > values.length)
              throw new Error(
                t('Cell-not-apply')
              );

            let cadenas =
              qCadena && qCadena.data ? qCadena.data.getCadena : undefined;
            let cCadena: { CargaIVA: number } | undefined = undefined;
            keys.forEach((k: string, i) => {
              const parsedValue = values[i] === null || values[i] === undefined || values[i] === '' ? 0 : parseInt(values[i]);
              const finalValue = isNaN(parsedValue) ? values[i] : parsedValue;
              if (!!k) obj[cleanVarName(k)] = finalValue;
              cAllItem.push({
                key: i,
                name: k.replace("(ap)", "(año pasado)"),
                value: finalValue,
              });
              if (i === 0) {
                cCadena = cadenas.filter(
                  (cadena: { Nombre: String }) =>
                    cadena.Nombre === `cad_${values[i]}`
                )[0];
              }
              if (i === 2) {
                cAllItem.push({
                  key: -1,
                  name: t('Iva-value'),
                  value: cCadena && cCadena.CargaIVA ? t('Yes') : "No",
                });
              }
            });

            cAllItems.push(cAllItem);
            error = getError(obj);
            cTable.push(obj);
          }
          setAllItems(cAllItems);
        }

        if (cTable.length === 0) error = i18n.language === "en" ? errorPlantillaEn : errorPlantilla;
        if (error) throw new Error(error);
        setTable(cTable);
      } catch (err: any) {
        let error = err.message;
        setNotification({ text: error, type: "error" });
        toggleNotification();
      }
    };
  };

  let qCadena = useQuery(
    gql`
      query {
        getCadena {
          UUID
          Nombre
          CargaIVA
        }
      }
    `
  );

  const addQuery = gql`
    mutation (
      $cadena: String
      $semana: Int
      $ano: Int
      $nlocalescomparables: Int
      $nlocalescomparablesquereportan: Int
      $ventascomparables: Int
      $ventascomparablesap: Int
      $ticketscomparables: Int
      $ticketscomparablesap: Int
      $aperturas: Int
      $cierres: Int
      $nlocales: Int
      $nlocalesquereportan: Int
      $ventastotales: Int
      $ventastotalesanopasado: Int
      $ticketstotales: Int
      $ticketstotalesanopasado: Int
      $ventasdelivery: Int
      $ventasdeliveryap: Int
      $ticketsdelivery: Int
      $ticketsdeliveryap: Int
      $localescondelivery: Int
      $localescondeliveryap: Int
      $ventastakeaway: Int
      $ventastakeawayap: Int
      $ticketstakeaway: Int
      $ticketstakeawayap: Int
      $ventaslocal: Int
      $ventaslocalap: Int
      $ticketslocal: Int
      $ticketslocalap: Int
      $ventascalle: Int
      $ventascalleap: Int
      $ticketscalle: Int
      $ticketscalleap: Int
      $ventasccomercial: Int
      $ventasccomercialap: Int
      $ticketsccomercial: Int
      $ticketsccomercialap: Int
      $ventasconcesiones: Int
      $ventasconcesionesap: Int
      $ticketsconcesiones: Int
      $ticketsconcesionesap: Int
      $ventasrestoubicaciones: Int
      $ventasrestoubicacionesap: Int
      $ticketsrestoubicaciones: Int
      $ticketsrestoubicacionesap: Int
      $ventasmadrid: Int
      $ventasmadridap: Int
      $ticketsmadrid: Int
      $ticketsmadridap: Int
      $ventasbarcelona: Int
      $ventasbarcelonaap: Int
      $ticketsbarcelona: Int
      $ticketsbarcelonaap: Int
      $ventaszona3: Int
      $ventaszona3ap: Int
      $ticketszona3: Int
      $ticketszona3ap: Int
      $ventaszona4: Int
      $ventaszona4ap: Int
      $ticketszona4: Int
      $ticketszona4ap: Int
      $ventaszona5: Int
      $ventaszona5ap: Int
      $ticketszona5: Int
      $ticketszona5ap: Int
      $ventaszona6: Int
      $ventaszona6ap: Int
      $ticketszona6: Int
      $ticketszona6ap: Int
      $ventasrealizadasenlamanana: Int
      $ventasrealizadasenlamananaap: Int
      $ticketsrealizadasenlamanana: Int
      $ticketsrealizadasenlamananaap: Int
      $ventasrealizadasenlatarde: Int
      $ventasrealizadasenlatardeap: Int
      $ticketsrealizadasenlatarde: Int
      $ticketsrealizadasenlatardeap: Int
      $ventasrealizadasencomidasdediario: Int
      $ventasrealizadasencomidasdediarioap: Int
      $ticketsrealizadasencomidasdediario: Int
      $ticketsrealizadasencomidasdediarioap: Int
      $ventasrealizadasencenasdediario: Int
      $ventasrealizadasencenasdediarioap: Int
      $ticketsrealizadasencenasdediario: Int
      $ticketsrealizadasencenasdediarioap: Int
      $ventasrealizadasencomidasdefindesemana: Int
      $ventasrealizadasencomidasdefindesemanaap: Int
      $ticketsrealizadasencomidasdefindesemana: Int
      $ticketsrealizadasencomidasdefindesemanaap: Int
      $ventasrealizadasencenasdefindesemana: Int
      $ventasrealizadasencenasdefindesemanaap: Int
      $ticketsrealizadasencenasdefindesemana: Int
      $ticketsrealizadasencenasdefindesemanaap: Int
      $localesselfstandingdurantelasemana: Int
      $localesselfstandingdurantelasemanaap: Int
      $ventascomparablesdelivery: Int
      $ventascomparablesdeliveryap: Int
      $ticketscomparablesdelivery: Int
      $ticketscomparablesdeliveryap: Int
      $ventascomparablestakeaway: Int
      $ventascomparablestakeawayap: Int
      $ticketscomparablestakeaway: Int
      $ticketscomparablestakeawayap: Int
      $ventascomparableslocal: Int
      $ventascomparableslocalap: Int
      $ticketscomparableslocal: Int
      $ticketscomparableslocalap: Int
      $ventascomparablescalle: Int
      $ventascomparablescalleap: Int
      $ticketscomparablescalle: Int
      $ticketscomparablescalleap: Int
      $ventascomparablesccomercial: Int
      $ventascomparablesccomercialap: Int
      $ticketscomparablesccomercial: Int
      $ticketscomparablesccomercialap: Int
      $ventascomparablesconcesiones: Int
      $ventascomparablesconcesionesap: Int
      $ticketscomparablesconcesiones: Int
      $ticketscomparablesconcesionesap: Int
      $ventascomparablesrestoubicaciones: Int
      $ventascomparablesrestoubicacionesap: Int
      $ticketscomparablesrestoubicaciones: Int
      $ticketscomparablesrestoubicacionesap: Int
      $ventascomparablesmadrid: Int
      $ventascomparablesmadridap: Int
      $ticketscomparablesmadrid: Int
      $ticketscomparablesmadridap: Int
      $ventascomparablesbarcelona: Int
      $ventascomparablesbarcelonaap: Int
      $ticketscomparablesbarcelona: Int
      $ticketscomparablesbarcelonaap: Int
      $ventascomparableszona3: Int
      $ventascomparableszona3ap: Int
      $ticketscomparableszona3: Int
      $ticketscomparableszona3ap: Int
      $ventascomparableszona4: Int
      $ventascomparableszona4ap: Int
      $ticketscomparableszona4: Int
      $ticketscomparableszona4ap: Int
      $ventascomparableszona5: Int
      $ventascomparableszona5ap: Int
      $ticketscomparableszona5: Int
      $ticketscomparableszona5ap: Int
      $ventascomparableszona6: Int
      $ventascomparableszona6ap: Int
      $ticketscomparableszona6: Int
      $ticketscomparableszona6ap: Int
      $ventascomparablesenlamanana: Int
      $ventascomparablesenlamananaap: Int
      $ticketscomparablesenlamanana: Int
      $ticketscomparablesenlamananaap: Int
      $ventascomparablesenlatarde: Int
      $ventascomparablesenlatardeap: Int
      $ticketscomparablesenlatarde: Int
      $ticketscomparablesenlatardeap: Int
      $ventascomparablescomidasdediario: Int
      $ventascomparablescomidasdediarioap: Int
      $ticketscomparablescomidasdediario: Int
      $ticketscomparablescomidasdediarioap: Int
      $ventascomparablescenasdediario: Int
      $ventascomparablescenasdediarioap: Int
      $ticketscomparablescenasdediario: Int
      $ticketscomparablescenasdediarioap: Int
      $ventascomparablescomidasfindesemana: Int
      $ventascomparablescomidasfindesemanaap: Int
      $ticketscomparablescomidasfindesemana: Int
      $ticketscomparablescomidasfindesemanaap: Int
      $ventascomparablescenasfindesemana: Int
      $ventascomparablescenasfindesemanaap: Int
      $ticketscomparablescenasfindesemana: Int
      $ticketscomparablescenasfindesemanaap: Int
      $localesmadrid: Int,
      $localesbarcelona: Int,
      $localeszona3: Int,
      $localeszona4: Int,
      $localeszona5: Int,
      $localeszona6: Int,
      $ventasagregadores: Int,
      $ventasagregadoresap: Int,
      $ticketsagregadores: Int,
      $ticketsagregadoresap: Int,
      $ventaspropios: Int,
      $ventaspropiosap: Int,
      $ticketspropios: Int,
      $ticketspropiosap: Int,
      $ventasturismo: Int,
      $ventasturismoap: Int,
      $ticketsturismo: Int,
      $ticketsturismoap: Int,
    ) {
      setVenta(
        input: {
          Usuario: { UUID: "000000000-0000-0000-0000-00000000000" }
          Cadena: { UUID: $cadena }
          Semana: $semana
          Anyo: $ano
          Actual: {
            Ventas: {
              Bruto: {
                Totales: $ventastotales
                Canal: {
                  Delivery: $ventasdelivery
                  TakeAway: $ventastakeaway
                  Local: $ventaslocal
                }
                Ubicacion: {
                  Calle: $ventascalle
                  CC: $ventasccomercial
                  Concesiones: $ventasconcesiones
                  Otros: $ventasrestoubicaciones
                }
                Region: {
                  Z1: $ventasmadrid
                  Z2: $ventasbarcelona
                  Z3: $ventaszona3
                  Z4: $ventaszona4
                  Z5: $ventaszona5
                  Z6: $ventaszona6
                }
                Momento: {
                  T1: $ventasrealizadasenlamanana
                  T2: $ventasrealizadasenlatarde
                  T3: $ventasrealizadasencomidasdediario
                  T4: $ventasrealizadasencenasdediario
                  T5: $ventasrealizadasencomidasdefindesemana
                  T6: $ventasrealizadasencenasdefindesemana
                }
              }
              Comparable: {
                Totales: $ventascomparables
                Canal: {
                  Delivery: $ventascomparablesdelivery
                  TakeAway: $ventascomparablestakeaway
                  Local: $ventascomparableslocal
                }
                Ubicacion: {
                  Calle: $ventascomparablescalle
                  CC: $ventascomparablesccomercial
                  Concesiones: $ventascomparablesconcesiones
                  Otros: $ventascomparablesrestoubicaciones
                }
                Region: {
                  Z1: $ventascomparablesmadrid
                  Z2: $ventascomparablesbarcelona
                  Z3: $ventascomparableszona3
                  Z4: $ventascomparableszona4
                  Z5: $ventascomparableszona5
                  Z6: $ventascomparableszona6
                }
                Momento: {
                  T1: $ventascomparablesenlamanana
                  T2: $ventascomparablesenlatarde
                  T3: $ventascomparablescomidasdediario
                  T4: $ventascomparablescenasdediario
                  T5: $ventascomparablescomidasfindesemana
                  T6: $ventascomparablescenasfindesemana
                }
              }
            }
            Tickets: {
              Bruto: {
                Totales: $ticketstotales
                Canal: {
                  Delivery: $ticketsdelivery
                  TakeAway: $ticketstakeaway
                  Local: $ticketslocal
                }
                Ubicacion: {
                  Calle: $ticketscalle
                  CC: $ticketsccomercial
                  Concesiones: $ticketsconcesiones
                  Otros: $ticketsrestoubicaciones
                }
                Region: {
                  Z1: $ticketsmadrid
                  Z2: $ticketsbarcelona
                  Z3: $ticketszona3
                  Z4: $ticketszona4
                  Z5: $ticketszona5
                  Z6: $ticketszona6
                }
                Momento: {
                  T1: $ticketsrealizadasenlamanana
                  T2: $ticketsrealizadasenlatarde
                  T3: $ticketsrealizadasencomidasdediario
                  T4: $ticketsrealizadasencenasdediario
                  T5: $ticketsrealizadasencomidasdefindesemana
                  T6: $ticketsrealizadasencenasdefindesemana
                }
              }
              Comparable: {
                Totales: $ticketscomparables
                Canal: {
                  Delivery: $ticketscomparablesdelivery
                  TakeAway: $ticketscomparablestakeaway
                  Local: $ticketscomparableslocal
                }
                Ubicacion: {
                  Calle: $ticketscomparablescalle
                  CC: $ticketscomparablesccomercial
                  Concesiones: $ticketscomparablesconcesiones
                  Otros: $ticketscomparablesrestoubicaciones
                }
                Region: {
                  Z1: $ticketscomparablesmadrid
                  Z2: $ticketscomparablesbarcelona
                  Z3: $ticketscomparableszona3
                  Z4: $ticketscomparableszona4
                  Z5: $ticketscomparableszona5
                  Z6: $ticketscomparableszona6
                }
                Momento: {
                  T1: $ticketscomparablesenlamanana
                  T2: $ticketscomparablesenlatarde
                  T3: $ticketscomparablescomidasdediario
                  T4: $ticketscomparablescenasdediario
                  T5: $ticketscomparablescomidasfindesemana
                  T6: $ticketscomparablescenasfindesemana
                }
              }
            }
            Locales: {
              Aperturas: $aperturas
              Cierres: $cierres
              Bruto: {
                Total: $nlocales
                Reportan: $nlocalesquereportan
                Self: $localesselfstandingdurantelasemana
                Delivery: $localescondelivery
                Region: {                              # ✅ AÑADIR ESTE BLOQUE
                  Z1: $localesmadrid
                  Z2: $localesbarcelona
                  Z3: $localeszona3
                  Z4: $localeszona4
                  Z5: $localeszona5
                  Z6: $localeszona6
                }
              }
              Comparable: {
                Total: $nlocalescomparables
                Reportan: $nlocalescomparablesquereportan
              }
            }
              Agregadores: {
                Ventas: $ventasagregadores
                VentasAP: $ventasagregadoresap
                Tickets: $ticketsagregadores
                TicketsAP: $ticketsagregadoresap
              }
              Propios: {
                Ventas: $ventaspropios
                VentasAP: $ventaspropiosap
                Tickets: $ticketspropios
                TicketsAP: $ticketspropiosap
              }
              Turismo: {
                Ventas: $ventasturismo
                VentasAP: $ventasturismoap
                Tickets: $ticketsturismo
                TicketsAP: $ticketsturismoap
              }
          }
          Anterior: {
            Ventas: {
              Bruto: {
                Totales: $ventastotalesanopasado
                Canal: {
                  Delivery: $ventasdeliveryap
                  TakeAway: $ventastakeawayap
                  Local: $ventaslocalap
                }
                Ubicacion: {
                  Calle: $ventascalleap
                  CC: $ventasccomercialap
                  Concesiones: $ventasconcesionesap
                  Otros: $ventasrestoubicacionesap
                }
                Region: {
                  Z1: $ventasmadridap
                  Z2: $ventasbarcelonaap
                  Z3: $ventaszona3ap
                  Z4: $ventaszona4ap
                  Z5: $ventaszona5ap
                  Z6: $ventaszona6ap
                }
                Momento: {
                  T1: $ventasrealizadasenlamananaap
                  T2: $ventasrealizadasenlatardeap
                  T3: $ventasrealizadasencomidasdediarioap
                  T4: $ventasrealizadasencenasdediarioap
                  T5: $ventasrealizadasencomidasdefindesemanaap
                  T6: $ventasrealizadasencenasdefindesemanaap
                }
              }
              Comparable: {
                Totales: $ventascomparablesap
                Canal: {
                  Delivery: $ventascomparablesdeliveryap
                  TakeAway: $ventascomparablestakeawayap
                  Local: $ventascomparableslocalap
                }
                Ubicacion: {
                  Calle: $ventascomparablescalleap
                  CC: $ventascomparablesccomercialap
                  Concesiones: $ventascomparablesconcesionesap
                  Otros: $ventascomparablesrestoubicacionesap
                }
                Region: {
                  Z1: $ventascomparablesmadridap
                  Z2: $ventascomparablesbarcelonaap
                  Z3: $ventascomparableszona3ap
                  Z4: $ventascomparableszona4ap
                  Z5: $ventascomparableszona5ap
                  Z6: $ventascomparableszona6ap
                }
                Momento: {
                  T1: $ventascomparablesenlamananaap
                  T2: $ventascomparablesenlatardeap
                  T3: $ventascomparablescomidasdediarioap
                  T4: $ventascomparablescenasdediarioap
                  T5: $ventascomparablescomidasfindesemanaap
                  T6: $ventascomparablescenasfindesemanaap
                }
              }
            }
            Tickets: {
              Bruto: {
                Totales: $ticketstotalesanopasado
                Canal: {
                  Delivery: $ticketsdeliveryap
                  TakeAway: $ticketstakeawayap
                  Local: $ticketslocalap
                }
                Ubicacion: {
                  Calle: $ticketscalleap
                  CC: $ticketsccomercialap
                  Concesiones: $ticketsconcesionesap
                  Otros: $ticketsrestoubicacionesap
                }
                Region: {
                  Z1: $ticketsmadridap
                  Z2: $ticketsbarcelonaap
                  Z3: $ticketszona3ap
                  Z4: $ticketszona4ap
                  Z5: $ticketszona5ap
                  Z6: $ticketszona6ap
                }
                Momento: {
                  T1: $ticketsrealizadasenlamananaap
                  T2: $ticketsrealizadasenlatardeap
                  T3: $ticketsrealizadasencomidasdediarioap
                  T4: $ticketsrealizadasencenasdediarioap
                  T5: $ticketsrealizadasencomidasdefindesemanaap
                  T6: $ticketsrealizadasencenasdefindesemanaap
                }
              }
              Comparable: {
                Totales: $ticketscomparablesap
                Canal: {
                  Delivery: $ticketscomparablesdeliveryap
                  TakeAway: $ticketscomparablestakeawayap
                  Local: $ticketscomparableslocalap
                }
                Ubicacion: {
                  Calle: $ticketscomparablescalleap
                  CC: $ticketscomparablesccomercialap
                  Concesiones: $ticketscomparablesconcesionesap
                  Otros: $ticketscomparablesrestoubicacionesap
                }
                Region: {
                  Z1: $ticketscomparablesmadridap
                  Z2: $ticketscomparablesbarcelonaap
                  Z3: $ticketscomparableszona3ap
                  Z4: $ticketscomparableszona4ap
                  Z5: $ticketscomparableszona5ap
                  Z6: $ticketscomparableszona6ap
                }
                Momento: {
                  T1: $ticketscomparablesenlamananaap
                  T2: $ticketscomparablesenlatardeap
                  T3: $ticketscomparablescomidasdediarioap
                  T4: $ticketscomparablescenasdediarioap
                  T5: $ticketscomparablescomidasfindesemanaap
                  T6: $ticketscomparablescenasfindesemanaap
                }
              }
            }
           Locales: {
                  Aperturas: $aperturas
                  Cierres: $cierres
                  Bruto: {
                    Total: $nlocales
                    Reportan: $nlocalesquereportan
                    Self: $localesselfstandingdurantelasemanaap
                    Delivery: $localescondeliveryap
                    Region: {                              
                      Z1: $localesmadrid
                      Z2: $localesbarcelona
                      Z3: $localeszona3
                      Z4: $localeszona4
                      Z5: $localeszona5
                      Z6: $localeszona6
                    }
                  }
                  Comparable: {
                    Total: $nlocalescomparables
                    Reportan: $nlocalescomparablesquereportan
                  }
                }
                Agregadores: {
                  Ventas: $ventasagregadores
                  VentasAP: $ventasagregadoresap
                  Tickets: $ticketsagregadores
                  TicketsAP: $ticketsagregadoresap
                }
                Propios: {
                  Ventas: $ventaspropios
                  VentasAP: $ventaspropiosap
                  Tickets: $ticketspropios
                  TicketsAP: $ticketspropiosap
                }
                Turismo: {
                  Ventas: $ventasturismo
                  VentasAP: $ventasturismoap
                  Tickets: $ticketsturismo
                  TicketsAP: $ticketsturismoap
                }
          }
          Modelizacion: 0
        }
      ) {
        UUID
        Error
      }
    }
  `;

  const [addRow] = useMutation(addQuery);

  async function sendQuery() {
  let cadenas = qCadena && qCadena.data ? qCadena.data.getCadena : undefined;
  setIndex(0);

  let error = "";
  for (let i = 0; i < table.length; i++) {
    let row = table[i];
    let codigodecadena = isNaN(row.codigodecadena)
      ? row.codigodecadena
      : `cad_${String(`${row.codigodecadena}`).padStart(6, "0")}`;

    if (codigodecadena.length === 10) {
      let cCadena = cadenas.filter(
        (cadena: { Nombre: String }) => cadena.Nombre === codigodecadena
      )[0];

      if (!cCadena) {
        error = t('Wrong-file-chain-format');
      } else {
        try {
          let resp = await addRow({
            variables: { cadena: cCadena.UUID, ...table[i] },
          });
          if (resp?.data?.setVenta?.Error) error = resp.data.setVenta.Error;
        } catch (e) {
          error = t('Error-loading-data');
        }
      }
    } else {
      console.log("Código de cadena mal formado");
      error = t('Wrong-file-critical');
    }

    if (error !== "") {
      setNotification({
        text: error ?? t('Error-loading-data'),
        type: "error",
      });
      break; 
    }
  }

  if (error === "") {
    setNotification({
      text: t('File-registred'),
      type: "success",
    });
  }
  toggleNotification();
  setTable(undefined);
}

function downloadTemplate() {
  const country = resolveCountry(window.location.hostname, i18n.language);
  const fileName = TEMPLATE_FILES[country] || TEMPLATE_FILES.ES;
  const url = "assets/templates/" + encodeURIComponent(fileName);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

  let buttonLoad: ICommandBarItemProps[] = [
    {
      key: "loadItems",
      text: (t('Save-data')),
      cacheKey: "loadKey",
      iconProps: { iconName: "Upload" },
      onClick: () => {sendQuery();}, 
    },
  ];
  let buttonDownload: ICommandBarItemProps[] = [
    {
      key: "loadItems",
      text: (t('Download-template')),
      cacheKey: "downloadKey",
      iconProps: { iconName: "Download" },
      onClick: downloadTemplate,
    },
  ];
  let farButtons: ICommandBarItemProps[] = [
    {
      key: "cancel",
      text: (t('Cancel')),
      iconProps: { iconName: "Cancel" },
      onClick: () => {
        setTable(undefined);
      },
    },
  ];

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept:
      "application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/x-csv, application/csv, application/x-csv",
    multiple: false,
    onDropAccepted: handleDropFile,
  });

  const style = useMemo(
    () => ({
      flex: 1,
      display: "flex",
      alignItems: "center",
      padding: "20px",
      borderWidth: 2,
      borderRadius: 2,
      borderColor: "#626262",
      backgroundColor: "#282828",
      borderStyle: "dashed",
      color: "#b8b8b8",
      outline: "none",
      transition: "border .24s ease-in-out",
      margin: "2px 4px",
      ...(isDragActive
        ? {
            color: "#046ae8",
            borderColor: "#074a9b",
            backgroundColor: "#1c2736",
          }
        : {}),
      ...(isDragAccept
        ? {
            color: "#06cf6c",
            borderColor: "#047d41",
            backgroundColor: "#1c362a",
          }
        : {}),
      ...(isDragReject
        ? {
            color: "#ec0835",
            borderColor: "#89031d",
            backgroundColor: "#311d1d",
          }
        : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  return (
    <>
      <div style={{ margin: "-14px 0 8px 0" }}>
        <Notification
          text={notification.text}
          type={notification.type}
          visible={showNotification}
          toggleVisibility={toggleNotification}
          autoHide={false}
          isMultiline={true}
        />
      </div>
      {!table && (
        <div className="table-container">
          <div className="table">
            <CommandBar items={buttonDownload} />
            <div className="container">
              <div {...getRootProps({ style })}>
                <input {...getInputProps()} />
                <div className="labelIcon">
                  <FontIcon iconName="CloudUpload" />
                  <p>
                    {t('Drag-drop')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {table && (
        <div className="table-container">
          <div className="table">
            <CommandBar items={buttonLoad} farItems={farButtons} />
            <div className="row header">
              <div className="cell headercell">{t('Fields-loaded')}</div>
              <div className="cell headercell">{t('Data-loaded')}</div>
            </div>
            {allItems[index].map(function (
              item: { key: number; name: string; value: any },
              i: number
            ) {
              return (
                <div key={item.key} className="row">
                  <div className="cell field">{item.name}</div>
                  <div className="cell value">{item.value}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default ExcelLoader;
